import { __awaiter, __generator } from "tslib";
import { sortableInputListKey } from '.';
import { createSortableInputListItemDriver } from '../sortable-input-list-item/driver';
import { createToggleDriver, popoverDriver } from '../../primitives/drivers';
import { createButtonDriver, createTextInputDriver } from '../../new-libby/drivers';
import { compKey } from './key';
export var createSortableInputListDriver = function (wrapper, globalWrapper) {
    var base = wrapper.$("." + sortableInputListKey);
    var popover = popoverDriver(globalWrapper);
    var toggleDriver = createToggleDriver(base);
    var sortableInputDriver = function (i) { return createSortableInputListItemDriver(base, globalWrapper, i); };
    return {
        getListTitle: function () {
            return base.$("." + compKey + "-title").text();
        },
        addListItem: function () { return __awaiter(void 0, void 0, void 0, function () {
            var btnContainer, button;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        btnContainer = base.$("." + compKey + "-add-item-btn-container");
                        button = createButtonDriver(btnContainer);
                        return [4 /*yield*/, button.click()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        isAddListItemDisabled: function () { return base.$("." + compKey + "-add-item-btn-container").hasClass('disabled'); },
        clickRemoveListButton: function () { return base.$("." + compKey + "-remove-list-button").click(); },
        isDeleteListBtnDisabled: function () { return base.$("." + compKey + "-remove-list-button").hasClass('disabled'); },
        removeList: function () {
            var deleteButton = createButtonDriver(popover, 0, "." + compKey + "-confirm-remove-btn");
            return deleteButton.click();
        },
        getListValues: function () { return base.$$("." + compKey + "-item").map(function (item) {
            var input = createTextInputDriver(item);
            return input.value();
        }); },
        isToggled: function () { return toggleDriver.isOn(); },
        toggle: function () { return toggleDriver.toggle(); },
        isToggleDisabled: function () { return toggleDriver.isDisabled(); },
        sortableInputDriver: sortableInputDriver,
        base: base,
    };
};
//# sourceMappingURL=driver.js.map